<template>
  <div v-if="integration" class="entity-details-card px-6 py-6 mb-5">
    <p class="has-text-weight-bold mb-4">
      {{ $t("mp:api_keys.integration.title") }}
    </p>
    <p class="mb-4">
      {{
        $t("mp:api_keys.integration.description", {
          type: integration.type,
          signingMode: integration.signingMode || "-",
        })
      }}
    </p>
    <validation-observer ref="observer">
      <BInputWithValidation
        v-for="field in URL_FIELDS"
        :key="field"
        class="mb-4"
        :label="$t(`mp:api_keys.integration.${field}`)"
        :rules="{ regex: HTTPS }"
        :disabled="!integration.merchantCanEditUrls"
        label-position="on-border"
        v-model="urls[field]"
      />
      <div v-if="integration.merchantCanEditUrls" class="is-flex">
        <b-button type="is-blue" class="ml-auto" @click="save">
          {{ $t("mp:api_keys.integration.button.save") }}
        </b-button>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import i18n from "../plugins/i18n";
import BInputWithValidation from "./input/BInputWithValidation";

const URL_FIELDS = ["orderCreateUrl", "orderCancelUrl", "stockUrl"];
const HTTPS = /^https:\/\/\S+$/;

/** The merchant's integration endpoints - shown only once Instacash has set up an integration. */
export default {
  name: "IntegrationUrlsCard",
  components: { BInputWithValidation },
  data() {
    return {
      URL_FIELDS,
      HTTPS,
      integration: null,
      urls: {},
    };
  },
  async mounted() {
    try {
      this.apply(await this.$store.dispatch("apiKeys/getIntegration"));
    } catch (e) {
      this.integration = null;
    }
  },
  methods: {
    apply(data) {
      this.integration = data || null;
      if (data) {
        this.urls = {
          orderCreateUrl: data.orderCreateUrl,
          orderCancelUrl: data.orderCancelUrl,
          stockUrl: data.stockUrl,
        };
      }
    },
    async save() {
      const valid = await this.$refs.observer.validate();
      if (!valid) {
        return;
      }
      try {
        this.apply(
          await this.$store.dispatch("apiKeys/updateIntegrationUrls", this.urls)
        );
        this.$buefy.toast.open({
          message: i18n.t("mp:api_keys.integration.message.saved"),
          type: "is-success",
        });
      } catch (e) {
        this.$buefy.toast.open({
          message: i18n.t("mp:api_keys.integration.message.failed"),
          type: "is-danger",
        });
      }
    },
  },
};
</script>
